import styled from "styled-components";

export const ModifyBiometricToogleSectionBox = styled.div`
    display:flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-color: ${props => props.theme.colors.backgroundDark};
    width: 80%;
    padding: 10px;
    margin: 10px 0px;
    border-radius: 10px;
`;
